// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as historyActionCreators from '../../actions/history';
import { StorageKeys } from '../../constants/storage';
import { useLocalStorage } from '../../hooks';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import { selectHistoryFilter } from '../../selectors/history/historyPrimary.selector';

import HistoryFiltersBar from './HistoryFiltersBar';

type HistoryFiltersBarContainerProps = {
  isCompact: boolean;
  setIsCompact: (...params: unknown) => unknown;
  className?: string;
};

const HistoryFiltersBarContainer = (ownProps: HistoryFiltersBarContainerProps) => {
  const currentFilter = useSelector(selectHistoryFilter);
  const [hasCompactHistorySwitchTooltipBeenViewed, setHasCompactHistorySwitchTooltipBeenViewed] = useLocalStorage(
    StorageKeys.HAS_COMPACT_HISTORY_SWITCH_TOOLTIP_BEEN_VIEWED,
    false,
  );

  const onCloseTooltip = useCallback(() => {
    setHasCompactHistorySwitchTooltipBeenViewed(true);
  }, [setHasCompactHistorySwitchTooltipBeenViewed]);

  const selectedProps = useMemo(
    () => ({
      currentFilter,
    }),
    [currentFilter],
  );

  const actionsProps = useBindActionsCreator(historyActionCreators);

  const otherProps = useMemo(
    () => ({
      showTooltip: !hasCompactHistorySwitchTooltipBeenViewed,
      onCloseTooltip,
    }),
    [hasCompactHistorySwitchTooltipBeenViewed, onCloseTooltip],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  return <HistoryFiltersBar {...enhancedProps} />;
};

export default HistoryFiltersBarContainer;
